import React from "react";
import PropTypes from "prop-types";

function Ico({ children, size = 15, viewBox = "0 0 24 24", fill = "none", stroke = true }) {
  return (
    <svg
      className="ic"
      viewBox={viewBox}
      width={size}
      height={size}
      fill={fill}
      stroke={stroke ? "currentColor" : undefined}
      strokeWidth={stroke ? "1.6" : undefined}
      strokeLinecap={stroke ? "round" : undefined}
      strokeLinejoin={stroke ? "round" : undefined}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

Ico.propTypes = {
  children: PropTypes.node,
  size: PropTypes.number,
  viewBox: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.bool,
};

export const IcoPin = (props) => (
  <Ico {...props}>
    <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.3" />
  </Ico>
);

export const IcoHome = (props) => (
  <Ico {...props}>
    <path d="M3 11.5 12 4l9 7.5" />
    <path d="M5.5 10v9a1 1 0 0 0 1 1H10v-5.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V20h3.5a1 1 0 0 0 1-1v-9" />
  </Ico>
);

export const IcoBed = (props) => (
  <Ico {...props}>
    <path d="M3 17.5v-5A1.5 1.5 0 0 1 4.5 11H18a2 2 0 0 1 2 2v4.5" />
    <path d="M3 17.5V20M20 17.5V20" />
    <path d="M3 12V8.5A1.5 1.5 0 0 1 4.5 7H9a1.5 1.5 0 0 1 1.5 1.5V11" />
  </Ico>
);

export const IcoCar = (props) => (
  <Ico {...props}>
    <path d="M4 16.5V12l2-5h12l2 5v4.5" />
    <path d="M4 16.5h16" />
    <circle cx="7.5" cy="16.5" r="1.4" />
    <circle cx="16.5" cy="16.5" r="1.4" />
  </Ico>
);

export const IcoWave = (props) => (
  <Ico {...props}>
    <path d="M2 16.5c1.5 1.3 3 1.3 4.5 0s3-1.3 4.5 0 3 1.3 4.5 0 3-1.3 4.5 0" />
    <path d="M2 11.5c1.5 1.3 3 1.3 4.5 0s3-1.3 4.5 0 3 1.3 4.5 0 3-1.3 4.5 0" />
  </Ico>
);

export const IcoSparkle = (props) => (
  <Ico {...props} fill="currentColor" stroke={false}>
    <path d="M12 2.5l1.8 5.4L19.2 9.7l-5.4 1.8L12 16.9l-1.8-5.4-5.4-1.8 5.4-1.8L12 2.5z" />
  </Ico>
);

export const IcoCamera = (props) => (
  <Ico {...props}>
    <path d="M4 8h3l1.5-2h7L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
    <circle cx="12" cy="13" r="3.4" />
  </Ico>
);

export const IcoBlueprint = (props) => (
  <Ico {...props}>
    <path d="M4 3h13l3 3v15H4z" />
    <path d="M17 3v3h3" />
    <path d="M8 12h8M8 16h5" />
  </Ico>
);

export const IcoCrane = (props) => (
  <Ico {...props}>
    <path d="M5 21V6l6-3v18" />
    <path d="M11 8h9l-3 3" />
    <path d="M17 11v6" />
    <path d="M3 21h14" />
  </Ico>
);

export const IcoMap = (props) => (
  <Ico {...props}>
    <path d="M9 4 3 6.5v14L9 18l6 2.5 6-2.5v-14L15 6.5 9 4z" />
    <path d="M9 4v14M15 6.5v14" />
  </Ico>
);

export const IcoPlay = (props) => (
  <Ico {...props}>
    <circle cx="12" cy="12" r="9.3" />
    <path d="M10 8.3l6.2 3.7-6.2 3.7z" fill="currentColor" stroke="none" />
  </Ico>
);

export const IcoShield = (props) => (
  <Ico {...props}>
    <path d="M12 3l7 3v5.5c0 4.8-3 8-7 9.5-4-1.5-7-4.7-7-9.5V6l7-3z" />
    <path d="M8.7 12.2l2.2 2.2 4.4-4.6" />
  </Ico>
);

export const IcoMedal = (props) => (
  <Ico {...props}>
    <circle cx="12" cy="10" r="6.3" />
    <path d="M9 15.3 7.3 21l4.7-2.6 4.7 2.6-1.7-5.7" />
    <path d="M9.3 10.2l1.8 1.8 3.6-3.8" />
  </Ico>
);

export const IcoCycle = (props) => (
  <Ico {...props}>
    <path d="M4.5 12a7.5 7.5 0 0 1 12.6-5.5M19.5 12a7.5 7.5 0 0 1-12.6 5.5" />
    <path d="M17 3.8v3.2h-3.2M7 20.2V17H10.2" />
  </Ico>
);

export const IcoLeaf = (props) => (
  <Ico {...props}>
    <path d="M5 19c8 0 14-6 14-14 0 0-11-1-14 8-1.4 4.3 0 6 0 6z" />
    <path d="M5 19c0-4 2-8 6-10" />
  </Ico>
);

export const IcoTarget = (props) => (
  <Ico {...props}>
    <circle cx="12" cy="12" r="8.3" />
    <circle cx="12" cy="12" r="4.6" />
    <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
  </Ico>
);

export const IcoCheckCircle = (props) => (
  <Ico {...props}>
    <circle cx="12" cy="12" r="9.3" />
    <path d="M8 12.3l2.6 2.6L16.3 9" />
  </Ico>
);

export const IcoFlask = (props) => (
  <Ico {...props}>
    <path d="M9.5 3.5h5M10 4v5.3L5.7 17c-.7 1.4.3 3 1.9 3h8.8c1.6 0 2.6-1.6 1.9-3L14 9.3V4" />
    <path d="M8.3 14.5h7.4" />
  </Ico>
);

export const IcoWhatsapp = ({ size = 15 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path
      d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46
      1.33 4.96L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.73 1.2h.01c5.46 0 9.9-4.45 9.9-9.91
      0-2.65-1.03-5.13-2.9-7A9.82 9.82 0 0 0 12.04 2zm0 1.67c2.19 0 4.25.85 5.79 2.4a8.2
      8.2 0 0 1 2.41 5.84c0 4.55-3.7 8.24-8.2 8.24a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.18
      8.18 0 0 1-1.26-4.37c0-4.55 3.7-8.25 8.23-8.25zm-4.5 4.36c-.16 0-.43.06-.65.31-.22.25-.86.84-.86
      2.04 0 1.2.88 2.36 1 2.53.13.16 1.71 2.6 4.14 3.65.58.25 1.03.4 1.38.51.58.18 1.11.16 1.53.1.47-.07
      1.42-.58 1.62-1.15.2-.56.2-1.04.14-1.14-.06-.1-.23-.16-.48-.28-.25-.13-1.42-.7-1.64-.78-.22-.08-.38-.13-.55.13-.16.25-.63.78-.77.94-.14.16-.28.18-.53.06-.25-.13-1.04-.38-1.98-1.22-.73-.65-1.23-1.45-1.37-1.7-.14-.25-.02-.38.11-.51.11-.11.25-.28.38-.42.13-.14.17-.25.25-.41.08-.16.04-.31-.02-.44-.06-.13-.55-1.35-.76-1.85-.2-.48-.4-.42-.55-.43z"
    />
  </svg>
);

IcoWhatsapp.propTypes = {
  size: PropTypes.number,
};

/**
 * Registro usado pelos campos "icone" do Strapi (enumeration). A chave gravada
 * no CMS escolhe o SVG aqui; chave desconhecida cai no check.
 */
export const ICONS = {
  escudo: IcoShield,
  medalha: IcoMedal,
  ciclo: IcoCycle,
  folha: IcoLeaf,
  alvo: IcoTarget,
  guindaste: IcoCrane,
  check: IcoCheckCircle,
  planta: IcoBlueprint,
  frasco: IcoFlask,
  onda: IcoWave,
  casa: IcoHome,
  mapa: IcoMap,
  brilho: IcoSparkle,
  camera: IcoCamera,
  play: IcoPlay,
  whatsapp: IcoWhatsapp,
};

export const ICON_KEYS = Object.keys(ICONS);

export function Icon({ name, ...props }) {
  const Component = ICONS[name] || ICONS.check;
  return <Component {...props} />;
}

Icon.propTypes = {
  name: PropTypes.string,
};
